module.exports = __webpack_public_path__ + "static/media/picture_predrag_hover.850c8ba6.jpg";